<template>
  <v-footer2 class="pa-3">
    All rights reserved to Silva's Software Consulting Services Inc. 
    <v-spacer></v-spacer>
    <div>1363 Partington Av | City of Windsor ON. Canada</div>
    <div>&copy; {{ new Date().getFullYear() }}</div>
    <div><span style="font-size: 8px;">Old Website: <a href="https://silva-consulting.azurewebsites.net" target="_blank">silva-consulting.azurewebsites.net</a></span> </div>
  </v-footer2>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>